import React from 'react'

const AssignDeparment = () => {
  return (
    <div>AssignDeparment</div>
  )
}

export default AssignDeparment